export default __webpack_public_path__ + "static/media/care_device_controller.62b27223.svg";